import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import Dropzone from 'react-dropzone'
import Icon from '@material-ui/core/Icon'
import { addNotification as notify } from 'reapop'
import { connect } from 'react-redux'

class Attachmentzone extends Component {
  constructor (props) {
    super(props)
    this.formData = new FormData()
    this.state = {
      filesAttached: []
    }
    this.reload = false
    this._reset = this._reset.bind(this)
  }

  _reset () {
    this.formData = new FormData()
    this.reload = false
    this.setState({ filesAttached: [] })
  }

  componentWillReceiveProps (nextProps) {
    this.reload = nextProps.reload

    if (this.reload === true) {
      this._reset()
    }
  }

  _handleCloseClick = (event, fileIndex) => {
    const filesAttached = this.state.filesAttached.filter((file, index) => index !== fileIndex)
    this.formData = new FormData()
    filesAttached.forEach(file => this.formData.append('documents', file))
    this.props.completeUpload(this.formData)
    this.setState({ filesAttached })
  }

  _showInvalidFileTypeError = () => {
    const acceptedFileExtensions = this._getAcceptedFileExtensions(this.props.referenceData)
    const languageContent = this.props.data.content
    this.props.notify({
      title: languageContent.error,
      message: `${languageContent.invalidFileTypeError} (${acceptedFileExtensions}).`,
      status: 'error',
      position: 'tr',
      dismissible: true,
      dismissAfter: 6000
    })
  }

  _showFileSizeExceededError = () => {
    const languageContent = this.props.data.content
    const { notify } = this.props
    notify({
      title: languageContent.error,
      message: languageContent.fileSizeExceedError,
      status: 'error',
      position: 'tr',
      dismissible: true,
      dismissAfter: 6000
    })
  }

  _validateFileSize = (newFiles, existingFiles) => {
    var totalSize = 0
    const MAX_ALLOWED_SIZE = 4194304
    var isError = false
    for (var index in newFiles) {
      totalSize = totalSize + newFiles[index].size
    }
    for (var ex in existingFiles) {
      totalSize = totalSize + existingFiles[ex].size
    }

    if (totalSize > MAX_ALLOWED_SIZE) {
      isError = true
    }

    return isError
  }

  _onDrop = files => {
    var isError = this._validateFileSize(files, this.state.filesAttached)
    if (isError === true) {
      this._showFileSizeExceededError()
      return
    }

    const filesAttached = [ ...this.state.filesAttached, ...files ]
    files.forEach(file => this.formData.append('documents', file))
    this.props.completeUpload(this.formData)
    this.setState({ filesAttached })
  }

  _getAcceptedFileExtensions = referenceData => {
    const acceptedFileExtensions = referenceData.referenceData.acceptedFileExtensions
    if (!acceptedFileExtensions || !acceptedFileExtensions.length) {
      return '';
    }

    return acceptedFileExtensions;
  }

  render () {
    const languageContent = this.props.lang
    const fileExtensions = this._getAcceptedFileExtensions(this.props.referenceData)
    return (
      <React.Fragment>
        <div className='dropzone'>
          <Dropzone
            multiple
            onDrop={this._onDrop}
            className='dropzone-rectangle'
            data-testid='dropzone-rectangle'
            accept={fileExtensions}
            onDropRejected={this._showInvalidFileTypeError}>
            <h5 data-testid='dropzone-text'>
              {languageContent.module.submitInquiry.dragDrop}
              <em> {languageContent.module.submitInquiry.or}</em> {languageContent.module.submitInquiry.browseFiles}
            </h5>
          </Dropzone>
        </div>
        <div style={{ marginBottom: '20px' }}>
          {
            this.state.filesAttached.map((file, index) =>
              <FilePreview key={index} filename={file.name} handleClose={event => this._handleCloseClick(event, index)}/>)
          }
        </div>
      </React.Fragment>
    )
  }
}

const FilePreview = ({ filename, handleClose }) => 
  <div>
    {filename}
    <span className='clear-attachment-button'>
      <Icon className='material-icons customstyle' styles={{ top: 10 }} onClick={handleClose}>
        clear
      </Icon>
    </span>
  </div>


function mapStateToProps (state) {
  return {
    fields: state.fields,
    data: state.pageContent,
    referenceData: state.referenceData.filter(item => item.type === 'REF_DATA').pop() || { referenceData: {} }
  }
}



export default connect(mapStateToProps, { notify }, null, { withRef: true })(Attachmentzone)



// WEBPACK FOOTER //
// ./src/forms/Attachmentzone.js